export const NOTIFICATION_SOUND_OFF = 'off' as const;

export type NotificationSoundId =
  | typeof NOTIFICATION_SOUND_OFF
  | 'trill'
  | 'step-up'
  | 'bubble-pop'
  | 'marimba'
  | 'metro'
  | 'retro'
  | 'sparkle'
  | 'strings';

export interface INotificationSound {
  id: NotificationSoundId;
  labelKey: string;
  asset: any;
}

export const NOTIFICATION_SOUNDS: INotificationSound[] = [
  {
    id: 'trill',
    labelKey: 'settings.notifications.sounds.trill',
    asset: require('@/assets/sounds/trill.mp3'),
  },
  {
    id: 'step-up',
    labelKey: 'settings.notifications.sounds.stepUp',
    asset: require('@/assets/sounds/step-up.mp3'),
  },
  {
    id: 'bubble-pop',
    labelKey: 'settings.notifications.sounds.bubblePop',
    asset: require('@/assets/sounds/bubble-pop.mp3'),
  },
  {
    id: 'marimba',
    labelKey: 'settings.notifications.sounds.marimba',
    asset: require('@/assets/sounds/marimba.mp3'),
  },
  {
    id: 'metro',
    labelKey: 'settings.notifications.sounds.metro',
    asset: require('@/assets/sounds/metro.mp3'),
  },
  {
    id: 'retro',
    labelKey: 'settings.notifications.sounds.retro',
    asset: require('@/assets/sounds/retro.mp3'),
  },
  {
    id: 'sparkle',
    labelKey: 'settings.notifications.sounds.sparkle',
    asset: require('@/assets/sounds/sparkle.mp3'),
  },
  {
    id: 'strings',
    labelKey: 'settings.notifications.sounds.strings',
    asset: require('@/assets/sounds/strings.mp3'),
  },
];

export const DEFAULT_NOTIFICATION_SOUND_ID: NotificationSoundId = 'trill';

const VALID_SOUND_IDS = new Set<NotificationSoundId>([
  NOTIFICATION_SOUND_OFF,
  ...NOTIFICATION_SOUNDS.map((s) => s.id),
]);

export function isValidNotificationSoundId(value: unknown): value is NotificationSoundId {
  return typeof value === 'string' && VALID_SOUND_IDS.has(value as NotificationSoundId);
}

export function getNotificationSound(id: NotificationSoundId | null | undefined): INotificationSound | null {
  if (!id || id === NOTIFICATION_SOUND_OFF) return null;
  return NOTIFICATION_SOUNDS.find((s) => s.id === id) ?? null;
}
